// extracted by mini-css-extract-plugin
export var link = "ht_R";